import a, { useMemo as d } from "react";
import { useTranslation as B } from "react-i18next";
import { DateTime as s, Duration as F } from "luxon";
import { QuantitySelector as L } from "../../../../../../features/common/components/forms/QuantitySelector/QuantitySelector.js";
import { Selector as v } from "../../../../../../features/common/components/forms/Selector/Selector.js";
import { tint as P } from "../../../../../../../common/libs/tint.js";
import { useEnvironment as D } from "../../../../../../features/common/hooks/environment/useEnvironment.js";
import { Autocomplete as w } from "../../../../../../features/google/components/Autocomplete/Autocomplete.js";
import { useWindowSize as A } from "../../../../../../features/dom/hooks/useWindowSize.js";
import { getCacheStorePrefix as I } from "../../OrderingForm/shared.js";
import { useBookingServiceAction as N } from "../hooks/useBookingServiceAction.js";
import { StepButton as W } from "../../StepButton/StepButton.js";
import { useBooking as O } from "../context.js";
import z from "../../../hooks/customization/useCustomization.js";
import { convertDateToLabel as Q } from "../../../../../../utils.js";
import n from "../bookingForm.module.scss.js";
function R() {
  return new Array(30).fill(0).map((r, m) => s.utc().startOf("day").plus({
    day: m
  }));
}
function K(r = "00:00", m = "23:59") {
  const l = [], p = s.fromFormat(r, "HH:mm"), t = s.fromFormat(m, "HH:mm"), i = F.fromISOTime("00:15");
  let c = p;
  for (; c <= t; )
    l.push(c.toFormat("HH:mm")), c = c.plus(i);
  return l;
}
function ae() {
  const { t: r } = B(), {
    setFormValue: m,
    form: l
  } = O(), {
    isMobile: p
  } = A(), {
    configuration: t,
    getTextTranslations: i
  } = z(), {
    proceed: c,
    isLoading: b
  } = N(), { mapApiKey: C } = D(), e = i("booking"), u = P(5e-3, (t == null ? void 0 : t.design.colors.general.highlightBackground) ?? "#222"), h = d(() => R().map((o) => ({
    value: o.toUnixInteger(),
    label: Q(o, r("today"), r("tomorrow"))
  })), []), k = h.find((o) => o.value === l.day), g = d(() => K().map((o) => ({
    value: o,
    label: o
  })), []), x = g.find((o) => o.value === l.hour), E = d(() => {
    const o = /* @__PURE__ */ new Set();
    return t == null || t.settings.configuration.scope.forEach(({ countryCode: f }) => {
      f && o.add(f);
    }), Array.from(o);
  }, [t]), S = (o) => {
    m("day", o);
  }, _ = (o) => {
    m("hour", o);
  }, T = (o) => {
    m("people", o);
  }, y = !!l.day && !!l.hour && !!l.people && !b, H = async () => {
    !y || !t || c(l);
  };
  return /* @__PURE__ */ a.createElement("div", { "data-testid": "reservation-step" }, /* @__PURE__ */ a.createElement("div", { className: n.title }, (e == null ? void 0 : e.reservation_title) || r("shopLanding.book.reservation.title")), /* @__PURE__ */ a.createElement("div", { className: n.inputWrapper }, /* @__PURE__ */ a.createElement(
    L,
    {
      label: (e == null ? void 0 : e.n_of_people) || r("shopLanding.book.nOfPeople") || "",
      min: 1,
      height: 33,
      defaultQuantity: l.people,
      fontSize: 13,
      onChange: (o) => T(o)
    }
  )), /* @__PURE__ */ a.createElement("div", { className: n.inputWrapper }, /* @__PURE__ */ a.createElement(
    v,
    {
      onChange: (o) => S(o == null ? void 0 : o.value),
      label: (e == null ? void 0 : e.day) || r("day"),
      textColor: t == null ? void 0 : t.design.colors.general.highlightText,
      backgroundColor: u,
      placeholder: (e == null ? void 0 : e.day_placeholder) || r("shopLanding.datetime.dayPlaceholder"),
      options: h,
      value: k
    }
  )), /* @__PURE__ */ a.createElement("div", { className: n.inputWrapper }, /* @__PURE__ */ a.createElement(
    v,
    {
      onChange: (o) => _(o == null ? void 0 : o.value),
      label: (e == null ? void 0 : e.hour) || r("hour"),
      textColor: t == null ? void 0 : t.design.colors.general.highlightText,
      backgroundColor: u,
      placeholder: (e == null ? void 0 : e.hour_placeholder) || r("shopLanding.datetime.hourPlaceholder"),
      options: g,
      value: x
    }
  )), /* @__PURE__ */ a.createElement("div", { className: n.inputWrapper }, /* @__PURE__ */ a.createElement(
    w,
    {
      onPlaceSelected: (o) => m("place", o),
      storePrefix: I(),
      place: l.place ?? void 0,
      design: {
        backgroundColor: (t == null ? void 0 : t.design.colors.general.highlightBackground) ?? "#000",
        textColor: (t == null ? void 0 : t.design.colors.general.highlightText) ?? "#FFF",
        menuOnTop: p
      },
      texts: {
        label: (e == null ? void 0 : e.autocomplete_label) || r("autocomplete.label") || void 0,
        placeholder: (e == null ? void 0 : e.autocomplete_placeholder) || r("autocomplete.label") || void 0,
        geolocation: (e == null ? void 0 : e.autocomplete_geolocation) || r("autocomplete.geolocation") || void 0
      },
      apiKey: C,
      country: E
    }
  )), /* @__PURE__ */ a.createElement(
    W,
    {
      buttonProps: {
        onClick: () => H()
      },
      disabled: !y,
      textColor: t == null ? void 0 : t.design.colors.general.primaryButtonText,
      backgroundColor: t == null ? void 0 : t.design.colors.general.primaryButtonBackground
    },
    (e == null ? void 0 : e.reservation_submit) || r("shopLanding.book.reservation.submit")
  ));
}
export {
  ae as ReservationStep
};
//# sourceMappingURL=ReservationStep.js.map
